import type { ServiceSummary, ServiceWidget } from '@frontend/types/adminhub';

interface ServiceCardProps {
  service: ServiceWidget;
  summary: ServiceSummary;
  expanded: boolean;
  onToggle: () => void;
}

export default function ServiceCard({ service, summary, expanded, onToggle }: ServiceCardProps) {
  return (
    <div className="ecosystem-card admin-widget-card admin-widget-nested">
      <button type="button" className="admin-widget-header" onClick={onToggle}>
        <div className="admin-widget-header-main">
          <h3 className="ecosystem-title">{service.title}</h3>
          <span className={`admin-status-badge status-${summary.status}`}>{summary.status}</span>
        </div>
        <span className="admin-widget-toggle">{expanded ? '▾' : '▸'}</span>
      </button>

      {expanded ? (
        <div className="admin-widget-body">
          <p className="ecosystem-description">{service.description}</p>
          <div className="admin-service-actions">
            {service.launchUrl ? (
              <a href={service.launchUrl} target="_blank" rel="noopener noreferrer" className="btn btn-secondary">{service.launchLabel || 'Open Service'}</a>
            ) : null}
            {service.adminUrl ? (
              <a href={service.adminUrl} target="_blank" rel="noopener noreferrer" className="btn btn-secondary">{service.adminLabel || 'Open Admin'}</a>
            ) : null}
            {service.wikiUrl ? (
              <a href={service.wikiUrl} target="_blank" rel="noopener noreferrer" className="btn btn-secondary">Open Wiki Docs</a>
            ) : null}
            {service.swaggerUrl ? (
              <a href={service.swaggerUrl} target="_blank" rel="noopener noreferrer" className="btn btn-secondary">Open Swagger</a>
            ) : (
              <span className={`admin-doc-badge swagger-${service.swaggerState}`}>Swagger {service.swaggerState}</span>
            )}
          </div>
          <div className="admin-service-meta">
            <div><strong>API base:</strong> {summary.url || service.apiBase}</div>
            <div><strong>Auth:</strong> {service.auth}</div>
            {summary.missing.length > 0 ? <div><strong>Missing config:</strong> {summary.missing.join(', ')}</div> : null}
          </div>
        </div>
      ) : null}
    </div>
  );
}
